
<transition name="fade">
  <div class='calendar' v-if="getCalendarVisibility">
    <div class='calendar-container'>
      <div class='calendar-line months'>
        <div class='calendar-line-item months-item' @click='moveToPreviousMonth()'>
          <div class="months-arrow-left calendar-line-item-text">&lt;</div>
        </div>
        <div class="calendar-line-item months-item" v-for="m in getFiveCurrentMonths"
          @click='moveToSelectedMonth(m.id)' :key="m.id"
          :class='{ "months-item-selected": m.selected && (m.year === getYearToday), "months-item-unactive": !m.active }'>
          <div class="calendar-line-item-text months-item-text">
            {{ m.label }} {{ m.year.toString().substr(2) }}
          </div>
        </div>
        <div v-if="showTodayBtn" class='calendar-line-item months-item' @click='goToThisMonthAndDay()'>
          <div class="months-arrow-right calendar-line-item-text">Aujourd'hui</div>
        </div>
        <div class='calendar-line-item months-item' @click='moveToNextMonth()'>
          <div class="months-arrow-right calendar-line-item-text">&gt;</div>
        </div>
      </div>
      <div class='calendar-line weekdays'>
        <div class='calendar-line-item weekdays-item' v-for='weekday in getWeekdays' :key="weekday.label">
          <div class="calendar-line-item-text weekdays-item-text">
            {{ weekday.label }}
          </div>
        </div>
      </div>
      <div class='week' v-for='(week, id) in getWeeks' :key="id">
        <calendar-day
          :class='{ "week-day-selected": day.isToday, "not-in-month": !day.inMonth, "week-day-small": (Object.keys(getWeeks).length > 5) }'
          v-for='(day, dayId) in week' :key="dayId" v-bind:day='day'></calendar-day>
      </div>
    </div>
  </div>
</transition>
